import React, {useEffect, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import classes from './apps.module.css';

const RELEASES_URL = '/downloads/releases.json';

/**
 * Страница приложений: Android / Windows + история версий.
 * Публичная — без обязательного логина.
 */
const Apps = () => {
    const navigate = useNavigate();
    const [releases, setReleases] = useState(null);
    const [error, setError] = useState(null);
    const [platform, setPlatform] = useState('android');

    useEffect(() => {
        let cancelled = false;
        (async () => {
            try {
                const res = await fetch(`${RELEASES_URL}?t=${Date.now()}`);
                if (!res.ok) throw new Error(`HTTP ${res.status}`);
                const data = await res.json();
                if (!cancelled) setReleases(data);
            } catch (e) {
                if (!cancelled) setError(e?.message || 'Не удалось загрузить список версий');
            }
        })();
        return () => {
            cancelled = true;
        };
    }, []);

    const android = releases?.android;
    const windows = releases?.windows;
    const active = platform === 'android' ? android : windows;
    const downloadUrl = active?.download_url || null;
    const portableUrl =
        active?.portable_download_url ||
        (active?.file_name ? `/downloads/${active.file_name}` : null) ||
        downloadUrl;
    const setupUrl = active?.setup_download_url || null;
    const fileName = active?.file_name || null;
    const setupFileName = active?.setup_file_name || null;
    const comingSoon = Boolean(active?.coming_soon);
    const canDownload = Boolean(downloadUrl && active?.latest);

    return (
        <div className={classes.page}>
            <div className={classes.inner}>
                <div className={classes.topRow}>
                    <button type="button" className={classes.backBtn} onClick={() => navigate(-1)}>
                        ← Назад
                    </button>
                    <h1 className={classes.pageTitle}>Приложение</h1>
                </div>

                <div className={classes.card}>
                    <p className={classes.intro}>
                        Официальные клиенты EasyFastVPN. Скачайте приложение, войдите тем же логином, что в
                        кабинете, и подключайтесь без сторонних клиентов. Инструкция по ручной установке
                        конфигов — в разделе «Инструкция».
                    </p>

                    <div className={classes.platforms}>
                        <button
                            type="button"
                            className={`${classes.platform} ${platform === 'android' ? classes.platformActive : ''}`}
                            onClick={() => setPlatform('android')}
                        >
                            Android
                        </button>
                        <button
                            type="button"
                            className={`${classes.platform} ${platform === 'windows' ? classes.platformActive : ''}`}
                            onClick={() => setPlatform('windows')}
                        >
                            Windows
                        </button>
                    </div>

                    {error && <p className={classes.error}>{error}</p>}

                    {!releases && !error && <p className={classes.muted}>Загрузка…</p>}

                    {active && (
                        <>
                            {comingSoon || !canDownload ? (
                                <div className={classes.soonBox}>
                                    <div className={classes.soonTitle}>Скоро</div>
                                    <p className={classes.muted}>
                                        Клиент для {platform === 'android' ? 'Android' : 'Windows'} готовится.
                                        Пока можно пользоваться веб-кабинетом и инструкцией по установке.
                                    </p>
                                    <button
                                        type="button"
                                        className={classes.secondaryBtn}
                                        onClick={() => navigate('/help')}
                                    >
                                        Открыть инструкцию
                                    </button>
                                </div>
                            ) : (
                                <div className={classes.downloadBox}>
                                    <div className={classes.versionRow}>
                                        <span className={classes.versionLabel}>Актуальная версия</span>
                                        <span className={classes.versionValue}>{active.latest}</span>
                                    </div>
                                    {platform === 'windows' && setupUrl ? (
                                        <div className={classes.downloadActions}>
                                            <a
                                                className={classes.downloadBtn}
                                                href={portableUrl}
                                                download={fileName || true}
                                            >
                                                Portable
                                            </a>
                                            <a
                                                className={`${classes.downloadBtn} ${classes.downloadBtnSecondary}`}
                                                href={setupUrl}
                                                download={setupFileName || true}
                                            >
                                                Установщик
                                            </a>
                                        </div>
                                    ) : (
                                        <a
                                            className={classes.downloadBtn}
                                            href={downloadUrl}
                                            download={fileName || true}
                                        >
                                            Скачать APK
                                        </a>
                                    )}
                                    <p className={classes.hint}>
                                        {platform === 'windows'
                                            ? 'Portable — один .exe без установки. Установщик — если нужна установка в меню «Пуск». При первом подключении Windows запросит права администратора для AmneziaWG.'
                                            : 'Установка не из Play Store: разрешите установку из этого источника в настройках Android.'}
                                    </p>
                                </div>
                            )}

                            {Array.isArray(active.changelog) && active.changelog.length > 0 && (
                                <div className={classes.changelog}>
                                    <h2 className={classes.changelogTitle}>История изменений</h2>
                                    {active.changelog.map((entry) => (
                                        <div key={entry.version} className={classes.changelogItem}>
                                            <div className={classes.changelogHead}>
                                                <span className={classes.changelogVer}>{entry.version}</span>
                                                {entry.date ? (
                                                    <span className={classes.changelogDate}>{entry.date}</span>
                                                ) : null}
                                            </div>
                                            <ul className={classes.notes}>
                                                {(entry.notes || []).map((note) => (
                                                    <li key={note}>{note}</li>
                                                ))}
                                            </ul>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

export default Apps;
